import React from 'react';
import { CSSObject } from '@emotion/react';

interface LandingPageSubheader {
  subheaderIcon?: JSX.Element;
  subheaderText: string;
}

const useStyles = (): Record<string, CSSObject> => ({
  subHeaderIcon: {
    display: 'flex',
    marginRight: 20
  },
  subHeaderText: {
    marginTop: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    whiteSpace: 'pre-line',
    marginBottom: 24
  }
});

function LandingPageSubheader({ subheaderIcon, subheaderText }: LandingPageSubheader): JSX.Element {
  const { subHeaderIcon, subHeaderText } = useStyles();

  return (
    <div css={subHeaderText}>
      {subheaderIcon && <div css={subHeaderIcon}>{subheaderIcon}</div>}
      {subheaderText}
    </div>
  );
}

export default LandingPageSubheader;
